var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.automatorModeTooltip,
    hideOnTargetClick: false
  }),expression:"{\n    content: automatorModeTooltip,\n    hideOnTargetClick: false\n  }"}],class:{
    'c-slider-toggle-button': true,
    'c-slider-toggle-button--right': _vm.isTextAutomator,
    ..._vm.tutorialClass
  },on:{"click":_vm.toggleAutomatorMode}},[_c('i',{staticClass:"fas fa-cubes"}),_c('i',{staticClass:"fas fa-code"})])
}
var staticRenderFns = []

export { render, staticRenderFns }